'use strict';

exports.__esModule = true;

var _property = require('./property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The object generated using this class should be
// initialized with any default configuration values
// as soon as your application starts. You can then
// use that object to fetch any global configurations.

var config = new _property2.default();

exports.default = config;